import axios from 'axios';
import cookie from 'react-cookies';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import getErrorMessage from '../helpers/getErrorMessage';

const axiosInstance = axios.create({
  baseURL: process.env.API_BASE_URL,
  responseType: 'json',
});

axiosInstance.interceptors.request.use((config) => {
  const newConfig = { ...config };
  // config.headers.common.Authorization = options();
  newConfig.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  newConfig.headers.common['accept-language'] = cookie.load('lang_market') || process.env.DEFAULT_LANG || 'en-US';
  return newConfig;
});

axiosInstance.interceptors.response.use((response) => response, (error) => {
  // Do something with response error

  if (error.response) {
    const errors = getErrorMessage(error.response);
    NotificationManager.error(errors);
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // console.log(error.response.data);
    // console.log(error.response.status);
    // console.log(error.response.headers);
    if (error.response.status === 401) {
      // store.dispatch(loginOutAction());
    } else {
      // setError(error.response);
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    // console.log('Error', error.message);
  }

  if (error.message === 'Network Error') {
    // toast.error(error.message, {autoClose: 2500, toastId: 'message'});
  }
  // console.log(error.message);
  return Promise.reject(error);
});

// const options = () => {
//     const token = getTokenAccess();
//     if (token) {
//         return "Bearer " + token
//     }
//
//     return {};
// };

export default axiosInstance;
